export const overview = () =>
  import(
    /* webpackChunkName: "base" */
    "@/components/Cases/Sponsorship/views/Overview"
  );

export const guide = () =>
  import(
    /* webpackChunkName: "base" */
    "@/components/Cases/Sponsorship/views/Guide"
  );

export const candidate = () =>
  import(
    /* webpackChunkName: "base" */
    "@/components/Cases/Sponsorship/views/Candidate"
  );

export const costs = () =>
  import(
    /* webpackChunkName: "base" */
    "@/components/Cases/Sponsorship/views/Fees"
  );

export const case_profile = () =>
  import(
    /* webpackChunkName: "base" */
    "@/components/Cases/Sponsorship/views/Profile"
  );

export const documents = () =>
  import(
    /* webpackChunkName: "base" */
    "@/components/Cases/Sponsorship/views/Documents"
  );

export const online_application = () =>
  import(
    /* webpackChunkName: "base" */
    "@/components/Cases/Sponsorship/views/OnlineApplication"
  );

const components = {
  overview,
  guide,
  candidate,
  costs,
  case_profile,
  documents,
  online_application,
};

export default {
  functional: true,

  props: {
    tab: {
      type: String,
    },
  },

  render(h, ctx) {
    return h(components[ctx.props.tab], ctx.data, ctx.children);
  },
};
